import { render, staticRenderFns } from "./_user-info.vue?vue&type=template&id=8295babc&scoped=true&"
import script from "./_user-info.vue?vue&type=script&lang=js&"
export * from "./_user-info.vue?vue&type=script&lang=js&"
import style0 from "./_user-info.vue?vue&type=style&index=0&id=8295babc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8295babc",
  null
  
)

export default component.exports